import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import RouterLink from 'src/components/ui/RouterLink';
import { formatRemainingUpdateTime } from 'src/utils/helpers/transformDate';

const hasLiveDeadline = (lines = []) =>
	lines.some((item) => item.countdownUntil || item.visibleUntil);

const PlateHead = (props) => {
	const { leftLines = [], rightLines = [] } = props;
	const [, setTick] = useState(0);

	useEffect(() => {
		if (!hasLiveDeadline(rightLines) && !hasLiveDeadline(leftLines)) {
			return undefined;
		}

		const id = setInterval(() => {
			setTick((value) => value + 1);
		}, 1000);

		return () => clearInterval(id);
	}, [leftLines, rightLines]);

	const renderItem = (item) => {
		if (item.visibleUntil && !formatRemainingUpdateTime(item.visibleUntil)) {
			return null;
		}

		const text = item.countdownUntil
			? formatRemainingUpdateTime(item.countdownUntil)
			: item.text;

		if (!text) return null;

		if (item.link) {
			return (
				<Link key={item.id} component={RouterLink} {...item.link}>
					<Typography variant="body2" {...item.typo}>
						{text}
					</Typography>
				</Link>
			);
		}

		return (
			<Typography
				variant="body2"
				color="secondary"
				key={item.id}
				{...item.typo}
			>
				{text}
			</Typography>
		);
	};

	const visibleRightLines = rightLines
		.map(renderItem)
		.filter(Boolean);

	return (
		<Stack direction="row" gap={4} justifyContent="space-between">
			{leftLines.length > 0 && (
				<Stack
					direction="row"
					gap={0.5}
					divider={<Typography color="secondary"> · </Typography>}
				>
					{leftLines.map(renderItem)}
				</Stack>
			)}
			{visibleRightLines.length > 0 && (
				<Stack direction="row" gap={0.5}>
					{visibleRightLines}
				</Stack>
			)}
		</Stack>
	);
};

const ItemShape = PropTypes.shape({
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	text: PropTypes.string,
	countdownUntil: PropTypes.string,
	visibleUntil: PropTypes.string,
	typo: PropTypes.shape(Typography.propTypes),
	link: PropTypes.shape(Link.propTypes),
});

PlateHead.propTypes = {
	leftLines: PropTypes.arrayOf(ItemShape),
	rightLines: PropTypes.arrayOf(ItemShape),
};

export default PlateHead;
